import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ReportsList from '@src/modules/regulatory-reporting/pages/ReportsList';
import SmoothTravelExposureReport from '@src/modules/regulatory-reporting/pages/reports/SmoothTravelExposure';
import SmoothTravelExposureLtpTargetReport from '@src/modules/regulatory-reporting/pages/reports/SmoothTravelExposureLtpTarget';

export default function Routes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/reports/smooth-travel-exposure`} component={SmoothTravelExposureReport} />
      <Route path={`${path}/reports/smooth-travel-exposure-ltp-target`} component={SmoothTravelExposureLtpTargetReport} />
      <Route path={`${path}/reports/`} component={ReportsList} />
    </Switch>
  );
}
